var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-parallax',{attrs:{"src":"https://cdn.vuetifyjs.com/images/parallax/material.jpg"}},[_c('vue-typed-js',{staticClass:"mx-auto",attrs:{"strings":_vm.mountTypedArray(),"loop":true}},[_c('h2',[_c('span',{staticClass:"typing"})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }